// 首页
import Axios from '@/assets/js/ajax'
const state = {
  topics: [], // 用户信息 初始化一个对象
  topic: {},
  hotTopics: [] // 热门专题
}

const getters = {
  topics: state => state.topics,
  topic: state => state.topic,
  hotTopics: state => state.hotTopics,
}

const mutations = {
  setTopics (state, payload) {
    state.topics = payload
  },
  setTopic (state, payload) {
    state.topic = payload
  },
  setHotTopic (state, payload) {
    state.hotTopics = payload
  }
}

const actions = {
  async getTopics ({commit}) {
    let {data} = await Axios.get('/admin/getTopics')
    commit('setTopics', data.data)
  },
  async getHotTopics ({commit}) {
    let {data} = await Axios.get('/admin/getTopics', {
      params: {
        isHotTopic: true
      }
    })
    commit('setHotTopic', data.data)
  },
  async getTopic ({commit}, payload) {
    let {data} = await Axios.get('/admin/getTopic', {
      params: {
        id: payload.id
      }
    })
    commit('setTopic', data.data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
